import React from 'react';
import { Card, CardBody, Flex, Tag, Text } from '@chakra-ui/react';
import { Terminal } from '../models/terminal';

interface TerminalCardProps {
  terminal: Terminal;
}

export const TerminalCard = ({ terminal }: TerminalCardProps) => {
  return (<>
    <Card variant="outlined" borderWidth="1px" borderColor="gray.200" borderRadius="xl" marginBottom="xl" maxW="70em" width="100%">
      <CardBody>
        <Flex justifyContent="space-between" marginBottom="xl">
          <Text fontWeight="medium">Número de serie: {terminal.serial_number}</Text>
          <Tag borderRadius="full" borderWidth="1px"
               borderColor={terminal.status === 1 ? 'green' : 'red'}
               backgroundColor={terminal.status === 1 ? 'success.200' : 'destructive.200'}
               colorScheme={terminal.status === 1 ? 'green' : 'red'}>
            {terminal.status === 1  ? 'Habilitada' : 'Deshabilitada'}
          </Tag>
        </Flex>

        <Flex>
          <Text color="neutral.800">Sucursal: {terminal.fantasy_name}</Text>
          <Text color="neutral.800" marginLeft="xxl">Modelo: {terminal.model}</Text>
          <Text color="neutral.800" marginLeft="xxl">Marca: {terminal.brand}</Text>
        </Flex>
      </CardBody>
    </Card>
  </>);
};
